import { convertToSecond } from 'duration-iso-8601';

const getColor = (firstSeconds, secondSeconds, lapColor) => {
  const first = convertToSecond(firstSeconds);
  const second = convertToSecond(secondSeconds);
  let difference = first - second;
  difference.toFixed(1);
  let color = false;
  // Green: Athlete is faster or up to 0,1s slower than the other
  // Yellow: Athlete is between 0,1 and 0,5s slower than the other
  // Orange: Athlete is between 0,5s and 1,0s slower than the other
  // Red: Athlete is between 1,0 and 1,5s slower than the other
  // DarkRed: Athlete is slower then 1,5 s than the other
  if (Math.sign(difference) === 0) {
    color = 'bg-green';
  } else if (Math.sign(difference) === -1) {
    color = 'bg-green';
  } else if (Math.sign(difference) === 1) {
    if (difference < 0.2) color = 'bg-green';
    if (difference > 0.1 && difference < 0.6) color = 'bg-yellow';
    if (difference > 0.5 && difference < 1.1) color = 'bg-orange';
    if (difference > 1.0 && difference < 1.6) color = 'bg-red';
    if (difference > 1.5) color = 'bg-darkred';
  }
  if (lapColor) {
    // If the Comparison athlete is faster than 1,0 sec, the performance box and the color of the text is green.
    // If the Comparison athlete is within 1,0 sec faster or slower, the performance box and the color of the text is grey.
    // If the Comparison athlete is slower than 1,0 sec, the performance box and the color of the text is red.
    color = 'bg-none';
    if (difference < -0.9) {
      color = 'bg-green';
    } else if (difference > 1) {
      color = 'bg-red';
    } else if (
      ((difference < 0.9 && difference > 0) || (difference > -0.9 && difference < 1)) &&
      difference !== 0
    ) {
      color = 'bg-grey';
    }
  }
  return color;
};

export { getColor };
